module.exports = __webpack_public_path__ + "static/media/non_ulip.5714f585.mp3";